import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS, apiS_withoutToken } from "./api-base"
import { getESGReqHeader } from "./tool-service";

// 查詢邀請碼紀錄
export const queryInviteRecordsList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010201'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010201")}`, method: 'post', data: ReqBody })
}


// 邀請公司註冊紀錄更新
export const updateInviteRecords = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010202")}`, method: 'post', data: ReqBody })
}

// 邀請公司註冊紀錄新增 before
export const B1010203Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010203'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010203",true)}`, method: 'post', data: ReqBody })
}

// 邀請公司註冊紀錄新增
export const createInviteRecords = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010203'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010203")}`, method: 'post', data: ReqBody })
}

export const SubAcctInviteRecords = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010204'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010204")}`, method: 'post', data: ReqBody })
}


// 查詢邀請碼資訊
export const getInviteRecordsInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B0000101'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("B0000101")}`, method: 'post', data: ReqBody })
}

// 邀請碼註冊 
export const createAcctByInviteRecords = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B0000102'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("B0000102")}`, method: 'post', data: ReqBody })
}


